namespace RioERP.Orders {
    export interface OrderBookForm {
        BookBookName: Serenity.StringEditor;
        ProductProductName: Serenity.StringEditor;
        OrderId: Serenity.IntegerEditor;
    }

    export class OrderBookForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.OrderBook';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderBookForm.init)  {
                OrderBookForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(OrderBookForm, [
                    'BookBookName', w0,
                    'ProductProductName', w0,
                    'OrderId', w1
                ]);
            }
        }
    }
}
